import script from "./AttributionLozenge.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttributionLozenge.vue?vue&type=script&setup=true&lang=ts"

import "./AttributionLozenge.vue?vue&type=style&index=0&id=cdfa5fd0&lang=scss"

const __exports__ = script;

export default __exports__